import React from 'react'
import { InputNumber } from 'primereact/inputnumber';

const InputPriceField = ({value,onChange,label}) => {
  return (
    <div className="flex-auto">
                <label htmlFor="stacked-buttons" className="font-bold block mb-2">{label}</label>
                <InputNumber inputId="stacked-buttons" value={value} onValueChange={onChange} showButtons mode="currency" currency="EUR" />
    </div>
  )
}

export default InputPriceField
